import { createAction, props } from '@ngrx/store';

export const toastBannerSuccess = createAction(
    '[toastBanner] success',
    props<{ title: string, body: string }>()
);

export const toastBannerWarning = createAction(
    '[toastBanner] warning',
    props<{ title: string, body: string }>()
);

export const toastBannerError = createAction(
    '[toastBanner] error',
    props<{ title: string, body: string }>()
);
